import { EntitySwitch, isKind } from '@backstage/plugin-catalog';
import {
  EntityPage as DefaultEntityPage
} from '@platt-internal/backstage-plugin-bootstrap-react';

export const entityPage = (
  <EntitySwitch>
    <EntitySwitch.Case if={isKind('component')} children={DefaultEntityPage.componentPage()} />
    <EntitySwitch.Case if={isKind('api')} children={DefaultEntityPage.apiPage()} />
    <EntitySwitch.Case if={isKind('group')} children={DefaultEntityPage.groupPage()} />
    <EntitySwitch.Case if={isKind('user')} children={DefaultEntityPage.userPage()} />
    <EntitySwitch.Case if={isKind('system')} children={DefaultEntityPage.systemPage()} />
    <EntitySwitch.Case if={isKind('domain')} children={DefaultEntityPage.domainPage()} />
    <EntitySwitch.Case if={isKind('resource')} children={DefaultEntityPage.resourceEntityPage()} />

    <EntitySwitch.Case>{DefaultEntityPage.defaultEntityPage()}</EntitySwitch.Case>
  </EntitySwitch>  
);
